module.exports = __webpack_public_path__ + "static/media/Telegram.f7fdbf9c.svg";